import React, { Component } from 'react';
import moment from 'moment';
import { browserHistory } from 'react-router';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { translate } from 'react-i18next';
import Form from 'antd/lib/form';
import Input from 'antd/lib/input';
import Button from 'antd/lib/button';
import { connect } from 'react-redux';
import CommunicationHelper from './CommunicationHelper';
import {
  loanStatus,
  loanGoalsT,
  loanStatusT,
  installmentStatus,
  accountRoles,
  encashmentStatusT,
} from '../../../common/enums';
import {
  formatDateTime,
  currencyFormatter,
  percentageFormatter,
  formatDate,
} from '../../../common/utils/helpers';
import {
    PaymentsCollapse,
    DocumentsCollapse,
    Calendar,
    EarlyRepaymentCollapse,
    OpenFileLink
} from '../../../common/components/data-display';
import RejectLoanModal from './RejectLoanModal';
import AcceptLoanModal from './AcceptLoanModal';
import { paymentStatus } from '../../../common/enums';
import InstallmentShiftModal from './InstallmentShiftModal';
import PaymentShiftModal from './PaymentShiftModal';
import {
  selectSetting,
} from '../../settings/ducks';
import {
  updateLoanProvisionFeeActions,
  fetchEarlyRepayRecordActions,
  returnOverpayActions,
  setPenaltySetting,
  savePayrollDeductionsNotesActions,
  fraudCheckActions
} from '../ducks';
import {
  shiftPaymentActions
} from '../../payment-management/ducks'
import DisposeLoanCollapse from '../../../common/components/data-display/DisposeLoanCollapse';
import { getDelayOfPayment } from '../../../common/utils/helpers';
import { selectAccount, selectIsAdmin } from '../../../features/auth/ducks';
import PenaltyFeeCollapse from '../../penalty-fee/components/PenaltyFeeCollapse';
import { Checkbox } from 'antd';
import PayrollDeductionsCollapse from '../../../common/components/data-display/PayrollDeductionsCollapse';
import MINIAPVCollapse from '../../../common/components/data-display/MINIAPVCollapse';
import { Alert, Modal } from 'antd'
import FraudCheckCollapse from '../../../common/components/data-display/FraudCheckCollapse';
import Collapse from 'antd/lib/collapse';
import DocumentsList from '../../../common/components/data-display/DocumentsList';
import ShowPsd2Button from '../../account-management/components/psd2/ShowPsd2Button';
import LoanDeviceSummary from './LoanDeviceSummary';
import LoanPhoneUsage from './phone-usage/LoanPhoneUsage';
const CollapsePanel = Collapse.Panel;

const formItemLayout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 14 },
};

const tailFormItemLayout = {
  wrapperCol: {
    span: 14,
    offset: 6,
  },
};

const findNextMonthInstallment = installmentDates => {
  let nextMonth = false
  let today = moment(new Date())
  let monthFromNow = today.add(1, 'month')
  installmentDates.forEach(date => {
    let installmentDate = moment(new Date(date))
    if (monthFromNow.isSame(installmentDate, 'month')){
      nextMonth = true
    }
  })
  return nextMonth

}


const isInBlackList = (loan) => {

  return loan.blacklist.filter(entry => {
    return entry.loanNumber === loan.loanNumber
  }).length > 0

}

const getFirstUnpaidInstallment = ({ installments }) =>
  installments.find(i => i.status === installmentStatus.UNPAID);

const renderRating = loan => {
  const rating = Number(loan.rating);

  if (loan.rating === null || typeof loan.rating === 'undefined' || !Number.isFinite(rating)) {
    return <span>-</span>;
  }

  const normalizedRating = Math.min(Math.max((rating - 1) / 4, 0), 1);
  const ratingColor = `hsl(${Math.round(120 - (normalizedRating * 120))}, 70%, 38%)`;
  const formattedRating = rating.toLocaleString('sk-SK', {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
  });

  return (
    <span>
      <span style={{ color: ratingColor, fontWeight: 600 }}>{formattedRating}</span>
      {loan.ratingCalculatedAt && (
        <small style={{ marginLeft: 6, color: '#777' }}>({formatDateTime(loan.ratingCalculatedAt)})</small>
      )}
    </span>
  );
};

const mapStateToProps = (state, props) => ({
  SHIFT_PAYMENT_MONTHS: selectSetting(state, 'SHIFT_PAYMENT_MONTHS'),
  SHIFT_PAYMENT_NUMBER: selectSetting(state, 'SHIFT_PAYMENT_NUMBER'),
  isAdmin: selectIsAdmin(state),
  account: selectAccount(state)
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      updateLoanProvisionFee: updateLoanProvisionFeeActions.request,
      fetchEarlyRepayRecord: fetchEarlyRepayRecordActions.request,
      setPenaltySetting: setPenaltySetting.request,
      returnOverpay: returnOverpayActions.request,
      shiftPayment: shiftPaymentActions.request,
      savePayrollDeductionsNotes: savePayrollDeductionsNotesActions.request,
      fraudCheck: fraudCheckActions.request
    },
    dispatch
  ),
});


const InvestmentsList = props => {
  const t = props.t

  const loanInvestments = props.investments.map((inv, index) => {
    return (
      <div key={inv.id} >
        <Form.Item {...formItemLayout} label={t('Meno priezvisko')}>
          <span>{props.loanAllocations[inv.AllocationId]}</span>
        </Form.Item>
        <Form.Item {...formItemLayout} label={t('ID investície')}>
          <Link to={`/admin/allocations/${inv.AllocationId}`}>{inv.AllocationId}</Link>
        </Form.Item>
        <Form.Item {...formItemLayout} label={t('Alokovaná suma')}>
          <span>{currencyFormatter(inv.amount)}</span>
        </Form.Item>
        <Form.Item {...formItemLayout} label={t('Úroková sadzba')}>
          <span>{percentageFormatter(inv.interest)}</span>
        </Form.Item>
        <br />
        {index + 1 < props.investments.length && <hr />}

      </div>
    )
  })
  return (
    <div>{loanInvestments}</div>
  );
}

@translate()
@connect(mapStateToProps, mapDispatchToProps)
@Form.create()
export default class LoanDetail extends Component {

  static propTypes = {
    t: PropTypes.func.isRequired,
    loan: PropTypes.object,
    loanAllocations: PropTypes.object,
    onAccept: PropTypes.func.isRequired,
    onReject: PropTypes.func.isRequired,
    onCancelLoan: PropTypes.func,
    isCancelling: PropTypes.bool,
    token: PropTypes.string.isRequired,
    getEarlyRepaymentAmount: PropTypes.func.isRequired,
    earlyRepayment: PropTypes.object,
    earlyRepayLoan: PropTypes.func.isRequired,
    resetEarlyRepayment: PropTypes.func.isRequired,
    earlyRepaymentRecord: PropTypes.object,
    onSubmitShift: PropTypes.func.isRequired,
    accountDevices: PropTypes.array,
    sameInstallAccountsCount: PropTypes.number,
    items: PropTypes.array,
    form: PropTypes.object,
    onOpenPsd2: PropTypes.func,
    psd2Enabled: PropTypes.bool,
  };
  state = {
    earlyRepaymentModalVisible: false,
    paymentShiftModalVisible: false,
    earlyRepaymentStatus: false,
    installmentModalVisible: false,
    returnOverpayModalVisible: false,
    cancelConfirmVisible: false,
  };
  componentDidMount() {
    onbeforeunload = e => {
      e.preventDefault();
      this.props.resetEarlyRepayment();
    };
    this.unlisten = browserHistory.listen(() => {
      this.props.resetEarlyRepayment();
    });
  }

  componentWillUnmount() {
    onbeforeunload = null;
    this.unlisten();
  }

  showEarlyRepaymentModal = () => {
    this.setState({
      earlyRepaymentModalVisible: true,
    });
  }

  handleEarlyRepaymentModalCancel = () => {
    this.props.getEarlyRepaymentAmount(moment().add(1,'day'));
    this.setState({
      earlyRepaymentModalVisible: false,
    });
  }

  showReturnOverpayModal = () => {
    this.setState({
      returnOverpayModalVisible: true,
    })
  }

  handleReturnOverpayModalCancel = () => {

    this.setState({
      returnOverpayModalVisible: false,
    });
  }

  showPaymentShiftModal = () => {
    this.setState({
      paymentShiftModalVisible: true,
    });
  }

  updateProvisioFee = () => {
    const input = this.refs.inputField.refs.input.value;
    const { loan, actions } = this.props;
    actions.updateLoanProvisionFee({
      loanId: loan.id,
      ProvisionFee: input
    });
  }

  returnOverpay = (values) => {
    const { loan, actions } = this.props;
    actions.returnOverpay({
      loanId: loan.id,
      data: values
    })
    this.setState({
      returnOverpay: true
    })
  }

  onShiftPayment = (paymentId, loanId) => {
    const { loan, actions } = this.props;
    actions.shiftPayment({ paymentId: paymentId , loanId: loanId});
  }

  handlePaymentShiftModalCancel = () => {
    this.setState({
      paymentShiftModalVisible: false,
    });
    // this.props.onSubmitShift();
  }

  showInstallmentModal = () => {
    this.setState({
      installmentModalVisible: true,
    })
  }

  handleInstallmentModalCancel = () => {
    this.setState({
      installmentModalVisible: false
    })
  }

  handleSetEarlyRepaymentStatus = () => {
    let newState = !this.state.earlyRepaymentStatus;
    this.setState({
      earlyRepaymentStatus: newState,
    })
  }

  handlePenaltySettings = e => {
    e.preventDefault();

    const { form, actions, loan } = this.props;

    form.validateFields((err, values) => {
      if (!err) {
        actions.setPenaltySetting({ loanId: loan.id, values: values });
        this.setState({
          noPenalty: values.noPenalty,
          noPenaltyNotification: values.noPenaltyNotification,
          blackList: values.blackList
        })
      }
    });

  }

  handleSavePayrollDeductionsNotes = notes => {
    const { actions, loan } = this.props;

    actions.savePayrollDeductionsNotes({loanId:loan.id, notes: notes})

  }

  startFraudCheck = () => {
    const {actions, loan} = this.props;
    actions.fraudCheck({loanId: loan.id})
  }

  handleCancelLoanClick = () => {
    this.setState({ cancelConfirmVisible: true });
  }

  handleCancelLoanConfirm = () => {
    const { onCancelLoan } = this.props;
    this.setState({ cancelConfirmVisible: false });
    if (onCancelLoan) {
      onCancelLoan();
    }
  }

  handleCancelLoanModalClose = () => {
    this.setState({ cancelConfirmVisible: false });
  }

  renderPrescoringResult = () => {
    const { loan, t } = this.props;
    if (!loan.prescoringResult) {
      return null;
    }

    const criteria = loan.prescoringResult.criteria;
    const matchedData = criteria.blacklistMatchedData;

    return (
      <div>
        <p>{t('Dôvod zamietnutia:')}</p>
        {criteria.tooYoung ? <p>{t('Menej ako 18 rokov')}</p> : null}
        {criteria.tooOld ? <p>{t('Viac ako 70 rokov')}</p> : null}
        {criteria.isUnemployed ? <p>{t('Nezamestnaný')}</p> : null}
        {criteria.isStudent ? <p>{t('Študent')}</p> : null}
        {criteria.isRetired ? <p>{t('Dôchodca')}</p> : null}
        {criteria.isOnBlacklist ?
          <div>
            {t('Je na black liste')}
            <p>
              {t('Zhodné atribúty: ')}
              {matchedData && matchedData.matchedAttributes && matchedData.matchedAttributes.length > 0 ? matchedData.matchedAttributes.join(', ') : t('Žiadne zhodné atribúty')}
            </p>
            <p>
              {matchedData && matchedData.matchedLoanId && <span>
                {`ID pôžičky na blackliste: `}
                <Link to={`/admin/loans/${matchedData.matchedLoanId}`}>{matchedData.matchedLoanId}</Link>
                </span>}
            </p>
          </div> : null
        }
        {criteria.hasSoldLoan ? <p>{t('Má odpredanú pôžičku')}</p> : null}
        {criteria.hasLoanInBuyoutProcess ? <p>{t('Má pôžičku v stave odkup pohľadávky')}</p> : null}
        {criteria.ratingNotBelowThreshold ? <p>{t('Známka je nad 4,0')}</p> : null}
        {criteria.faceSimilarityFailed ? <p>{t('Príliš nízka podoba tváre z biometrie')}</p> : null}
      </div>
    )
  }

  getLoanDocuments = () => {
    const {loan} = this.props;

    if (!loan.documents) {
      return [];
    }

    return loan.documents.documents.map(doc => {
      return {
        id: doc.file.id,
        contractNumber: doc.file.name,
        fileId: doc.file.id,
        type: doc.type,
        updatedAt: doc.file.updatedAt,
        createdAt: doc.file.createdAt
      }
    });
  }

  render() {
    const {
      loan,
      account,
      loanAllocations,
      onAccept,
      onReject,
      onCancelLoan,
      isCancelling,
      token,
      t,
      getEarlyRepaymentAmount,
      earlyRepayment,
      earlyRepayLoan,
      earlyRepaymentRecord,
      SHIFT_PAYMENT_MONTHS,
      SHIFT_PAYMENT_NUMBER,
      shiftInstallments,
      isAdmin,
      items,
      form,
      accountDevices,
      sameInstallAccountsCount
    } = this.props;
    const payments = loan.payments.filter(p => p.status === paymentStatus.ASSIGNED_TO_LOAN || p.status === paymentStatus.RETURN_OVERPAY);
    const installments = loan.installments.filter(i => i.status == installmentStatus.UNPAID && i.principalAmount === i.principalUnpaid && i.interestAmount === i.interestUnpaid).map(i => i.month);
    const delay = getDelayOfPayment(loan.installments, loan.payments);
    const installmentDates = loan.installments.map(i => i.paymentDue)
    let nextMonth = findNextMonthInstallment(installmentDates)

    const { getFieldDecorator } = form
    return (
      <div>
        {
          loan.blacklist.length > 0 && <Alert type="error" description={
            <p>
              {loan.blacklist.map(record => {
                return <p style={{color: 'black'}}>{`Pôžička tohto užívateľa s VS ${record.loanNumber} zaradená do Blacklistu od ${formatDate(record.created)} s poznámkou: ${record.note ? record.note : 'Bez poznámky'}`}</p>
              })}
            </p>
          }/>
        }
        <Form.Item {...formItemLayout} label={t('Komunikácia')}>
          <CommunicationHelper loan={loan}></CommunicationHelper>

        </Form.Item>

        <Form.Item {...formItemLayout} label={t('ID')}>
          <span>{loan.id}</span>
        </Form.Item>

        <Form.Item {...formItemLayout} label={t('Meno dlžníka')}>
          <Link to={`/admin/accounts/${loan.accountId}/profile`}>{loan.accountName}</Link>
        </Form.Item>

        <LoanDeviceSummary
          accountId={loan.accountId}
          isAdmin={isAdmin}
          devices={accountDevices}
          sameInstallAccountsCount={sameInstallAccountsCount}
        />
        <LoanPhoneUsage loanId={loan.id} loanNumber={loan.loanNumber} isAdmin={isAdmin} />
        {/*
        { loan.disposeLoan &&
          <Form.Item {...formItemLayout} label={t('Odpredaná za')}>
            <span>{currencyFormatter(loan.disposeLoan.amount)}</span>
          </Form.Item>
        } */}

        <Form.Item {...formItemLayout} label={t('Výška')}>
          <span>{currencyFormatter(loan.amount)}</span>
        </Form.Item>

        <Form.Item {...formItemLayout} label={t('Dôvod pôžičky')}>
          <span>{loanGoalsT[loan.goal]}</span>
        </Form.Item>

        <Form.Item {...formItemLayout} label={t('Dĺžka (v mesiacoch)')}>
          <span>{loan.months}</span>
        </Form.Item>

        <Form.Item {...formItemLayout} label={t('Úrok')}>
          <span>{percentageFormatter(loan.interest)}</span>
        </Form.Item>

        <Form.Item {...formItemLayout} label={t('Poistenie')}>
          <span>{loan.insurance ? (t('Balík ') + loan.insurance) : t('Nie')}</span>
        </Form.Item>

        {
          loan.insuranceInfo &&
            <Form.Item {...formItemLayout} label={t('Výška poistenia')}>
              <span>{currencyFormatter(loan.insuranceInfo.insuranceAmount)}</span>
            </Form.Item>
        }

        <Form.Item {...formItemLayout} label={t('Poplatok za poskytnutie')}>
          {(loan.status === "POD" || loan.status === "NPI") ? (
            <div>
              <Input style={{ display: 'inline', width: '50%' }} size="small" type="text" defaultValue={loan.ProvisionFee} ref="inputField" />
              <Button style={{ display: 'inline' }} size="small" type="primary" onClick={this.updateProvisioFee}>
                {t('Uložiť')}
              </Button>
            </div>
          ) : (
            <span>{currencyFormatter(loan.ProvisionFee)}</span>
          )
          }
        </Form.Item>

        <Form.Item {...formItemLayout} label={t('Systémový stav')}>
          <span>{loanStatusT[loan.status]}{loan.status == "ZAM" ? " (" + loan.rejectReason + ")" : ""}</span>
          {
            loan.status === loanStatus.PRESCORING_FAILED ? this.renderPrescoringResult() : null
          }
        </Form.Item>

        <Form.Item {...formItemLayout} label={t('Stav inkasa')}>
          <span>{encashmentStatusT[loan.encashmentStatus]}</span>
        </Form.Item>

        <Form.Item {...formItemLayout} label={t('Známka')}>
          {renderRating(loan)}
        </Form.Item>

        <Form.Item {...formItemLayout} label={t('Variabilný symbol platby')}>
          <span>{loan.loanNumber}</span>
        </Form.Item>

        <Form.Item {...formItemLayout} label={t('Expirácia')}>
          <span>{formatDateTime(loan.expirationDate)}</span>
        </Form.Item>

        <Form.Item {...formItemLayout} label={t('Vytvorené')}>
          <span>{formatDateTime(loan.createdAt)}</span>
        </Form.Item>

        <Form.Item {...formItemLayout} label={t('Upravené')}>
          <span>{formatDateTime(loan.updatedAt)}</span>
        </Form.Item>



        {
          <Form onSubmit={this.handlePenaltySettings}>
            {[loanStatus.AKT, loanStatus.UP1, loanStatus.UP2, loanStatus.ODP].includes(loan.status) &&
            <Form.Item {...formItemLayout} label={t('Nevyrubovať sankčné poplatky')} >
              {getFieldDecorator('noPenalty', {
                initialValue: loan.noPenalty,
                valuePropName: 'checked'
              })(<Checkbox checked={loan.noPenaltyNotification} ></Checkbox>)}

            </Form.Item>}

            {[loanStatus.AKT, loanStatus.UP1, loanStatus.UP2, loanStatus.ODP].includes(loan.status) &&
            <Form.Item {...formItemLayout} label={t('Neposielať upomienky')}>
              {getFieldDecorator('noPenaltyNotification', {
                initialValue: loan.noPenaltyNotification,
                valuePropName: 'checked'
              })(<Checkbox checked={loan.noPenaltyNotification} ></Checkbox>)}
            </Form.Item>}

            <Form.Item {...formItemLayout} label={t('Blacklist')}>
              {getFieldDecorator('blackList', {
                initialValue: isInBlackList(loan),
                valuePropName: 'checked'
              })(<Checkbox checked={isInBlackList(loan)} ></Checkbox>)}
            </Form.Item>

            <Form.Item {...formItemLayout} label={t('Dôvod')}>
            {
              getFieldDecorator('note', {
                initialValue: loan.blacklist.length > 0 ? (loan.blacklist.find(entry => entry.loanNumber === loan.loanNumber) ? (loan.blacklist.find(entry => entry.loanNumber === loan.loanNumber).note || '' ) : '' ): ''
              })(
                <Input style={{ display: 'inline', width: '50%' }} size="small" type="text" />
              )
            }

            </Form.Item>

            <Form.Item {...tailFormItemLayout}>
              <Button type="primary" htmlType="submit" size="small">
                {t('Odoslať nastavenie')}
              </Button>
            </Form.Item>
          </Form>
        }

        { typeof(loan.MINIData) === 'undefined' &&  <div className="ant-row ant-form-item">
          <div className="ant-col-6 ant-form-item-label">
            <label>
              MINI v čase žiadosti
          </label>
          </div>
          <div className="ant-col-14">
            <div className="ant-form-item-control">
              <span>
                {loan.dlznaSuma == "" ? " Nedostupné" : (loan.dlznaSuma == 0 ? " Klient bez pôžičky" : (new Date(loan.datumSplatnosti) < new Date() ? " Pôžička po splatnosti od " + new Date(loan.datumSplatnosti).getDate() + "." + (new Date(loan.datumSplatnosti).getMonth() + 1) + "." + new Date(loan.datumSplatnosti).getFullYear() + " - " + loan.dlznaSuma + " EUR" : " Otvorená pôžička do " + loan.datumSplatnosti + " - " + loan.dlznaSuma + " EUR"))}
              </span>
            </div>
          </div>
        </div> }
        {loan.investments.length > 0 ?
          <Form.Item {...formItemLayout} label={t('Investície:')}>
            <InvestmentsList investments={loan.investments} loanAllocations={loanAllocations} t={t} />
          </Form.Item> : null}
        {[loanStatus.AKT, loanStatus.UP1, loanStatus.UP2].includes(loan.status) &&
          loan.ShiftCount < SHIFT_PAYMENT_NUMBER &&
          <Form.Item {...tailFormItemLayout}>
            <Button size="default" className="btn-inline" onClick={this.showPaymentShiftModal}>{t('Posun splátok')}</Button>
            <PaymentShiftModal
              visible={this.state.paymentShiftModalVisible}
              handleModalCancel={this.handlePaymentShiftModalCancel}
              paymentNumbers={installments}
              maxMonthMovement={SHIFT_PAYMENT_MONTHS}
              loanId={loan.id}
            ></PaymentShiftModal>
          </Form.Item>
        }
        {([loanStatus.UP1, loanStatus.UP2, loanStatus.UP3, loanStatus.AKT, loanStatus.ODP].includes(loan.status) && nextMonth) && <Form.Item {...tailFormItemLayout}>
              <Button size="default" type="btn-inline" onClick={this.showInstallmentModal}>
                {t('Posunúť dátum splátok')}
              </Button>
              <InstallmentShiftModal
                visible={this.state.installmentModalVisible}
                handleModalCancel={this.handleInstallmentModalCancel}
                loanId={loan.id}
                date={new Date()}
                shiftInstallments={shiftInstallments}
              >
              </InstallmentShiftModal>
            </Form.Item>
        }

        <DocumentsCollapse
          contracts={loan.contracts}
          token={token}
          accountRole={accountRoles.DEBTOR}
        />

        <Collapse>
          <CollapsePanel header={t('Zobraziť dokumenty')}>
            <DocumentsList
              documents={this.getLoanDocuments()}
              token={token}
              accountRole={account.role}
              showCreatedAt={true}
            />

            <ShowPsd2Button loans={[this.props.loan]} onOpenPsd2={this.props.onOpenPsd2} psd2Enabled={this.props.psd2Enabled} />
          </CollapsePanel>
        </Collapse>

        { typeof(loan.MINIData) !== 'undefined' && <MINIAPVCollapse
          data={loan.MINIData  }
          token={token}
          type={'MINI'}
        />}

        { typeof(loan.APVData) !== 'undefined' && <MINIAPVCollapse
          data={loan.APVData  }
          token={token}
          type={'APV'}
        />}

        { [loanStatus.AKT, loanStatus.UP1, loanStatus.UP2, loanStatus.ODP, loanStatus.PUZV].includes(loan.status) && <EarlyRepaymentCollapse
          visible={this.state.earlyRepaymentModalVisible}
          handleModalCancel={this.handleEarlyRepaymentModalCancel}
          getEarlyRepaymentAmount={getEarlyRepaymentAmount}
          amount={earlyRepayment && earlyRepayment.earlyRepaymentAmount}
          rozdiel={earlyRepayment && earlyRepayment.rozdiel}
          amountNonPayedPrincipal={earlyRepayment && earlyRepayment.amountNonPayedPrincipal}
          amountFee={earlyRepayment && earlyRepayment.amountFee}
          penaltyFee={earlyRepayment && earlyRepayment.penaltyFee}
          nearestRepaymentDate={earlyRepayment && earlyRepayment.nearestDateForEarlyRepayment}
          repaymentDate={earlyRepayment && earlyRepayment.date}
          earlyRepayLoan={earlyRepayLoan}
          tailFormItemLayout={this.tailFormItemLayout}
          showEarlyRepaymentModal={this.showEarlyRepaymentModal}
          rerenderPageFunc={this.handleSetEarlyRepaymentStatus}
          loan={loan}
          earlyRepaymentRecord={earlyRepaymentRecord}
        />}

        { ([loanStatus.UP3, loanStatus.ODP].includes(loan.status) || loan.status === loanStatus.POOD) && <DisposeLoanCollapse
          loan={loan}
          items={items}
          token={token}
          accountRole={accountRoles.DEBTOR}
        />}

        {([loanStatus.UP1, loanStatus.UP2, loanStatus.UP3, loanStatus.ODP, loanStatus.POOD].includes(loan.status) || items.length > 0) && <PenaltyFeeCollapse
          items={items}
          loanId={loan.id}
          />
        }

        {payments.length > 0 &&
          <PaymentsCollapse
            visible={this.state.returnOverpayModalVisible}
            handleModalCancel={this.handleReturnOverpayModalCancel}
            showReturnOverpayModal={this.showReturnOverpayModal}
            loanId={loan.id}
            payments={payments}
            isAdmin={isAdmin}
            loanPaid={loan.status === loanStatus.UZV || loan.status === loanStatus.PUZV}
            amountEarlyFee={(earlyRepaymentRecord && earlyRepaymentRecord.amount) || 0}
            returnOverpay={this.returnOverpay}
            account={loan.account}
            fullAccountName={loan.accountName}
            onShiftPayment={this.onShiftPayment}
            role={account.role}
          />
        }

        {
          <PayrollDeductionsCollapse
            loanId={loan.id}
            payrollDeductionsSentDate={loan.payrollDeductionsSentDate}
            loanNotes={loan.payrollDeductionsNotes}
            token={token}
            employersData={loan.account.employersData}
            onSaveNotes={ this.handleSavePayrollDeductionsNotes}
          />
        }

        {
          <FraudCheckCollapse
            fraudCheck={loan.fraudCheckHistory}
            startCheck={this.startFraudCheck}
            accountRole={account.role}
          />
        }

        {loan.installments.length > 0 && (
          <Calendar
            installments={loan.installments}
            firstUnpaidInstallment={getFirstUnpaidInstallment(loan)}
            unpaidAmount={loan.unpaidAmount}
          />
        )}

        {loan.status === loanStatus.POD && (
          <Form.Item {...tailFormItemLayout}>
            <AcceptLoanModal onSubmit={onAccept}>
              <Button size="default" type="primary">{t('Akceptovať')}</Button>
            </AcceptLoanModal>
            <RejectLoanModal onSubmit={onReject}>
              <Button size="default">{t('Zamietnuť')}</Button>
            </RejectLoanModal>
          </Form.Item>
        )}

        {(loan.status === loanStatus.CNPZ || loan.status === loanStatus.CNPP) && (
          <Form.Item {...tailFormItemLayout}>
            <RejectLoanModal onSubmit={onReject}>
              <Button size="default">{t('Zamietnuť')}</Button>
            </RejectLoanModal>
          </Form.Item>
        )}

        {[
          loanStatus.NPI, loanStatus.NEP, loanStatus.POD, loanStatus.SCH,
          loanStatus.AUT, loanStatus.CNPZ, loanStatus.CNPP, loanStatus.CNUD,
          loanStatus.WAITING_CONTRACT_SIGNATURE, loanStatus.CONTRACT_SIGNATURE_PENDING,
        ].includes(loan.status) && onCancelLoan && (
          <Form.Item {...tailFormItemLayout} className="cancel-loan-form-item">
            <Button
              size="default"
              type="danger"
              loading={isCancelling}
              onClick={this.handleCancelLoanClick}
            >
              {t('Zrušiť žiadosť')}
            </Button>
            <Modal
              title={t('Zrušiť žiadosť')}
              visible={this.state.cancelConfirmVisible}
              onOk={this.handleCancelLoanConfirm}
              onCancel={this.handleCancelLoanModalClose}
              okText={t('Zrušiť žiadosť')}
              cancelText={t('Späť')}
              okType="danger"
            >
              <p>{t('Naozaj si prajete zrušiť túto žiadosť? Táto akcia je nevratná.')}</p>
            </Modal>
          </Form.Item>
        )}

        {(loan.status !== loanStatus.CNPZ && loan.status !== loanStatus.CNPP && loan.status !== loanStatus.POD) && (
            <div style={{ margin: '30px 0'}}>
                <OpenFileLink
                    isButton
                    href={`${process.env.REACT_APP_API_URL}/loan/transactionExport?token=${token}&loanId=${loan.id}`}
                >
                    {t('Export transakcií')}
                </OpenFileLink>

            </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/loan-management/components/LoanDetail.js